export default {
  blue: "#07c",
  bg: "#f6f5f6",
  blackBg: "#000000",
  bgLight: "#DEDDDD",
  border: "#EBEBEB",
  primary: "#D1d1d1",
  metaText: "#969a9b",
  /* InWave's colors below here */
  green: "#2BB99E",
  yellow: "#FFC61A",
  red: "#F95050",
  gray: "#121212",
  black: "#263039",
  white: "#FFFFFF",
  purple: "#2B80B9",
  meta: "#969a9b",
  opaqueMeta: "rgb(255,255,255, 0.5)",
};
